/** Map dashboard paths → permission keys used by /permissions/me */
const PATH_PERMS = [
  ["/day-end", "day_end"],
  ["/transfers", "transfers"],
  ["/purchase-invoices", "purchases"],
  ["/floor-setup", "areas"],
  ["/permissions", "settings"],
  ["/subscription", "settings"],
  ["/reconcile", "reconcile"],
  ["/pos", "pos"],
  ["/orders", "orders"],
  ["/tables", "tables"],
  ["/menu", "menu"],
  ["/inventory", "inventory"],
  ["/vendors", "vendors"],
  ["/customers", "customers"],
  ["/reports", "reports"],
  ["/channels", "channels"],
  ["/delivery", "delivery"],
  ["/reservations", "reservations"],
  ["/tasks", "tasks"],
  ["/attendance", "attendance"],
  ["/settings", "settings"],
  ["/waiter", "waiter"],
  ["/kitchen", "kitchen"],
  ["/kds", "kds"],
  ["/calls", "calls"],
  ["/chain", "chain"],
  ["/accounting", "accounting"],
  ["/printers", "printers"],
  ["/whatsapp", "whatsapp"],
  ["/brands", "brands"],
  ["/aggregator", "aggregator"],
  ["/mess", "mess"],
  ["/sms", "sms"],
  ["/waste", "inventory"],
  ["/reviews", "customers"],
  ["/staff", "settings"],
  ["/approvals", "orders"],
  ["/tokens-desk", "orders"],
];

export function pathAllowed(pathname, perms) {
  if (!perms) return true;
  if (perms.all || (perms.permissions || []).includes("*")) return true;
  const list = perms.permissions || [];
  const hit = PATH_PERMS.find(([p]) => pathname === p || pathname.startsWith(`${p}/`));
  if (!hit) return true;
  return list.includes(hit[1]);
}

export function navAllowed(to, perms) {
  return pathAllowed(to, perms);
}
